var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.213 15.693c-.223.34-.223.78 0 1.12 3.792 5.8 8.366 8.646 13.787 8.646s9.995-2.845 13.787-8.647c.223-.34.223-.78 0-1.12-3.792-5.8-8.366-8.646-13.787-8.646S6.005 9.891 2.213 15.693M.5 14.573C4.648 8.228 9.837 5 16 5s11.352 3.228 15.5 9.573a3.07 3.07 0 0 1 0 3.359c-4.148 6.345-9.337 9.573-15.5 9.573S4.648 24.277.5 17.932a3.07 3.07 0 0 1 0-3.359M16 22.39a6.138 6.138 0 1 1 0-12.275 6.138 6.138 0 0 1 0 12.275m0-2.046a4.092 4.092 0 1 0 0-8.183 4.092 4.092 0 0 0 0 8.184z"
})));
export default SvgShow;